module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/refresh_icon-2ad0f51fbc1b43564c00e9f9e9e48c48.svg";